export { ArticleGeneral } from "./article-general";
